import React, { useState, useEffect } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import DispatcherService from '../../services/DispatcherService'

import View from '../form/View'
import Header from '../form/Header'
import Footer from '../form/Footer'
import Loader from '../form/Loader'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    minHeight: 0,
    overflowX: 'hidden'
  },
  content: {
    flex: 1,
    flexGrow: 1,
    overflowY: 'auto',
    margin: '0 36px',
    flexDirection: 'column',
  },
  loader: {
    justifyContent: 'center'
  },
  documentTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '28px',
    '@media(max-height: 976px)': {
      fontSize: '20px',
    },
  },
  documentContent: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '24px',
    '@media(max-height: 976px)': {
      fontSize: '18px',
    },
  },
  space: {
    height: '16px'
  }
}))

function DetailsScreen (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ document, setDocument ] = useState()

  useEffect(() => {
    const loadDocument = async () => {
      const document = await DispatcherService.loadPublicDocument(props.publicDocumentId)
      setDocument(document)
    }
    loadDocument()
  }, []);

  let parts
  if (document && document.content) {
    parts = document.content.split('\n')
  }
  return (
    <View className={styles.root}>
      <Header 
        title={props.title}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />
      { !document ? <>
        <View className={`${styles.content} ${styles.loader}`}>
          <Loader message='Carregando o documento'/>
        </View>
      </> : <>
        <View className={styles.content}>
          <p className={styles.documentTitle}>{document.title}</p>
          { parts.map(part => (
            <p className={styles.documentContent}>{part}</p>
          ))}
        </View>
      </>}
      <View className={styles.space}></View>
      <Footer 
        onBack={() => props.back()}
      />
    </View>
  )
}

export default DetailsScreen